// Persistence helpers for the current photo session group contact id (the
// "current album" the merfoto welcome page shows).
//
// The id is kept in localStorage so the selection survives reloads. Clearing
// the selection used to persist by writing the value straight to localStorage,
// which stores the literal strings "undefined"/"null"; reading those back later
// produced a bogus id that was then sent to the API. Keep the storage free of
// those string forms so a cleared selection reads back as "no selection".
export const PHOTO_SESSION_GROUP_CONTACT_ID_STORAGE_KEY = "photoSessionGroupContactId"

const BOGUS_STRING_VALUES = ["", "null", "undefined"]

export function readPhotoSessionGroupContactId(storage) {
  const value = storage.getItem(PHOTO_SESSION_GROUP_CONTACT_ID_STORAGE_KEY)

  if (value === null || BOGUS_STRING_VALUES.includes(value)) {
    return null
  }

  return value
}

export function persistPhotoSessionGroupContactId(storage, value) {
  if (value && !BOGUS_STRING_VALUES.includes(value)) {
    storage.setItem(PHOTO_SESSION_GROUP_CONTACT_ID_STORAGE_KEY, value)
  } else {
    storage.removeItem(PHOTO_SESSION_GROUP_CONTACT_ID_STORAGE_KEY)
  }
}
